export const exerciseOptions = {
 method: 'GET',

 headers: {
   
   
   'X-RapidAPI-Host': 'exercisedb.p.rapidapi.com',
   'X-RapidAPI-Key': process.env.REACT_APP_RAPID_API_KEY
 },
};

export const youtubeOptions = {
  method: 'GET',
  
  headers: {
    'X-RapidAPI-Key': '76db6dadc5mshd37aca0cd49505bp1a7880jsn3707b07c37f3',
    'X-RapidAPI-Host': 'youtube-search-and-download.p.rapidapi.com'
  },
};

export const fetchData = async (url, options) => {
 const res = await fetch(url, options);
 const data = await res.json();

 return data;
};
